import styled from "@emotion/styled";
import Colors from "styles/colors";
const TAB_CONTENT_PADDING = "40px";
export const StyledSideBySideTabsAndProcessTabsMobileComponent = styled.div`
  .mobile-wrapper {
    .mobile-timer-tabs-component {
      padding: 0;

      .vertical-timer-tab-mobile-component {
        padding: 0 ${TAB_CONTENT_PADDING};

        &:after {
          content: "";
          position: absolute;
          left: 0;
          display: block;
          height: 1px;
          width: 100%;
          background-color: ${Colors.asphalt};
        }

        .vertical-timer-tab-mobile-content-container {
          padding-bottom: 20px;
        }

        .vertical-timer-tab-mobile-title {
          padding-top: 44px;
          padding-bottom: 8px;
        }

        &:has(> div.vertical-timer-tab-mobile-title-selected) {
          background-color: var(--selected-tab-background-color);
        }

        .process-tabs {
          .mobile-wrapper {
            .use-cases-tabs-mobile-component {
              .mobile-tabs-component {
                .mobile-tabs-navigation {
                  margin-right: -${TAB_CONTENT_PADDING};
                  padding-left: 0;
                }
              }
            }
          }
        }

        .vertical-timer-tab-mobile-content {
          .paragraph-wrapper .paragraph-body {
            font-size: 1rem;
            margin-bottom: 24px;
          }
        }
      }
    }
  }
`;
